<template>
  <div>
    <div v-if="this.$store.state.customModule.indOverall" class="div-subject">
      <img class="img-content" src="http://hpc.devotedigital.cn/resources/img/industry.jpg">
      <!-- 两个线条 -->
      <div class="line">
        <img class="lineUpper" src="http://hpc.devotedigital.cn/resources/img/lineUpper.png">
        <div class="divText">{{ this.$store.state.customModule.indOverallDivText }}</div>
        <img class="lineLower" src="http://hpc.devotedigital.cn/resources/img/lineLower.png">
      </div>
      <!-- 轮播区域 -->
      <div class="rotation">
        <img
          v-if="this.$store.state.customModule.isImgOrVideo==='img'"
          class="middleImg"
          :src="this.$store.state.customModule.indOverallImg"
        >
        <video
          v-if="this.$store.state.customModule.isImgOrVideo==='video'"
          autoplay
          loop
          preload
          class="middleImg"
          :src="this.$store.state.customModule.indOverallImg"
          x5-video-player-type="h5"
          x5-video-player-fullscreen="true"
          x-webkit-airplay="allow"
          webkit-playsinline
          playsinline
          controls="controls"
        />
      </div>
      <img
        v-if="this.$store.state.customModule.indOverallBtnShow!=='leftHide'&&this.$store.state.customModule.indOverallBtnShow!=='allHide'"
        class="leftBtnImg"
        src="http://hpc.devotedigital.cn/resources/img/nextlevel.png"
        @click="next"
      >
      <img
        v-if="this.$store.state.customModule.indOverallBtnShow!=='rightHide'&&this.$store.state.customModule.indOverallBtnShow!=='allHide'"
        class="rightBtnImg"
        src="http://hpc.devotedigital.cn/resources/img/lowerlevel.png"
        @click="lower"
      >
      <img class="img-close" src="http://hpc.devotedigital.cn/resources/img/close.png" @click="overallShowClick">
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      stroe: this.$store.state.customModule
      // 存放索引
    }
  },
  created() {},
  methods: {
    overallShowClick() {
      this.$store.commit('customModule/setIndOverall', false)
      this.$store.commit('customModule/setIndustry', true)
      // this.$store.commit('customModule/setIndustryImgShow', 'rightHide')
      this.$store.commit('customModule/setIndoverallImgArrayClear')
      this.$emit('divClose', 'http://hpc.devotedigital.cn/resources/img/production.png')
      // 判断左右按钮显示
      if (this.stroe.imgArray[0] === 'left0') {
        this.$store.commit('customModule/setIndustryImgShow', 'rightHide')
      } else if (this.stroe.imgArray[1] === 'left3') {
        this.$store.commit('customModule/setIndustryImgShow', 'leftHide')
      } else {
        this.$store.commit('customModule/setIndustryImgShow', 'notHide')
      }
    },
    next() {
      var index = this.stroe.indOverallArray.indexOf(this.stroe.indOverallImg)
      index--
      this.changeImg(index)
    },
    lower() {
      var index = this.stroe.indOverallArray.indexOf(this.stroe.indOverallImg)
      index++
      this.changeImg(index)
    },
    changeImg(index) {
      this.$store.commit(
        'customModule/setIndOverallImg',
        this.stroe.indOverallArray[index]
      )
      if (index === 0) {
        this.$store.commit('customModule/setIndOverallBtnShow', 'leftHide')
      } else if (index === this.stroe.indOverallArray.length - 1) {
        this.$store.commit('customModule/setIndOverallBtnShow', 'rightHide')
      } else {
        this.$store.commit('customModule/setIndOverallBtnShow', 'notHide')
      }
    }
  }
}
</script>
<style lang='scss' scoped>
.div-subject {
  position: absolute;
  width: 61vw;
  height: 32vw;
  left: 50%;
  top: 55%;
  transform: translate(-50%, -50%);
  // background-color: black;
  .img-content {
    position: absolute;
    width: 61vw;
    height: 32vw;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
  }
  .img-close {
    position: absolute;
    right:13px;
    top: 30px;
    width: 60px;
    height: 60px;
    cursor: pointer;
  }
  .divText {
    position: absolute;
    top: 48px;
    width: 100%;
    text-align: center;
    display: inline-block;
    word-break: break-all;
    font-size: 18px;
    color: rgb(255, 255, 255);
    line-height: 35px;
  }
  .line {
    position: absolute;
    width: 80%;
    height: 20%;
    left: 10%;
    top: -17%;
    // background: wheat;
  }
  .lineUpper {
    display: none;
    margin-top: 30px;
    margin-bottom: 10px;
    width: 110%;
  }
  .lineLower {
    display: none;
    margin-top: 10px;
    width: 110%;
  }
  .rotation {
    position: absolute;
    width: 61vw;
    height: 32vw;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    // background-color: yellow;
  }
  .leftBtnImg {
    position: absolute;
    top: 45%;
    left: 5%;
    width: 5%;
    cursor: pointer;
    transform: translate(-50%);
  }
  .rightBtnImg {
    position: absolute;
    top: 45%;
    right: 4%;
    width: 5%;
    cursor: pointer;
    transform: translate(-50%);
  }
  .middleImg {
    position: absolute;
    left: 48%;
    top: 6%;
    transform: translate(-50%);
    // height: 100%;
    width: 1200px;
    height: 700px;
  }
}
</style>
